export const DATA_QUALITY_OPTIONS = [
  {
    label: '전체',
    value: 'All',
  },
  {
    label: '양호 95% 이상',
    value: 'high',
  },
  {
    label: '양호 80% 이상 95% 미만',
    value: 'medium',
  },
  {
    label: '양호 80% 미만',
    value: 'low',
  },
];

export const DATE_OPTIONS = [
  {
    label: '최근 1일',
    value: 1,
  },
  {
    label: '최근 3일',
    value: 3,
  },
  {
    label: '최근 7일',
    value: 7,
  },
  {
    label: '최근 14일',
    value: 14,
  },
  {
    label: '최근 30일',
    value: 30,
  },
  {
    label: '최근 60일',
    value: 60,
  },
];

export const SORT_BY_OPTIONS = [
  {
    label: '최근 평가 순',
    value: '-collectedAt',
  },
  {
    label: '양호율 높은 순',
    value: '-goodRatio',
  },
  {
    label: '양호율 낮은 순',
    value: 'goodRatio',
  },
];

export const DATA_ZONE_OPTIONS = [
  {
    label: '전체',
    value: 'All',
  },
  {
    label: 'Gold',
    value: 'gold',
  },
  {
    label: 'Silver',
    value: 'silver',
  },
  {
    label: 'Bronze',
    value: 'bronze',
  },
];
